import React from 'react';
import AlertBox from '../../../components/ui/AlertBox';

/** Caja "¿Cómo funciona?" con pasos numerados, sobre AlertBox info. */
interface StepGuideProps {
  title?: string;
  description: React.ReactNode;
  steps: string[];
  className?: string;
  style?: React.CSSProperties;
}

const StepGuide: React.FC<StepGuideProps> = ({
  title = '¿Cómo funciona?',
  description,
  steps,
  className,
  style,
}) => (
  <AlertBox variant="info" title={title} className={className} style={style}>
    <div className="space-y-2">
      {typeof description === 'string' ? <p>{description}</p> : description}
      <div className="flex flex-wrap items-start mt-2 gap-x-6 gap-y-2 text-xs">
        {steps.map((step, i) => (
          <div key={i} className="flex items-center">
            <div className="h-6 w-6 rounded-full bg-blue-200 dark:bg-blue-500/30 flex items-center justify-center text-blue-700 dark:text-blue-300 font-bold mr-2 text-xs flex-shrink-0">
              {i + 1}
            </div>
            <span>{step}</span>
          </div>
        ))}
      </div>
    </div>
  </AlertBox>
);

export default StepGuide;
